import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { doNotCallRestrictionTypeDataSource } from 'infrastructure/data-sources/do-not-call-restriction-types';

import type { IDoNotCallRestrictionTypeItem } from 'infrastructure/data-sources/do-not-call-restriction-types';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<
  IDoNotCallRestrictionTypeItem['id'],
  IDoNotCallRestrictionTypeItem
>[];

interface IProps extends Omit<IBaseSelectBoxProps, 'options'> {
  withNull?: boolean;
  type?: 'clinic' | 'patient';
}

const DoNotCallRestrictionTypeSelectBox: React.FC<IProps> = ({
  withNull,
  type = 'patient',
  ...props
}) => {
  const options: Options = useMemo(() => {
    const dataSource = doNotCallRestrictionTypeDataSource({ withNull, type });

    return dataSource.map((el) => ({
      value: el.id,
      label: el.name,
      record: el,
    }));
  }, [withNull, type]);

  return <BaseSelectBox options={options} {...props} />;
};

export default DoNotCallRestrictionTypeSelectBox;
